import Searchable from './searchable'
import { Opened } from './opener'

export default {
  extends: Searchable,

  props: {
    navigational: {
      type: Boolean,
      default: true
    },

    listUrl: {
      type: String,
    },
  },

  data() {
    return {
      filter: {},
      openedProduct: {}
    }
  },

  inject: ['openerSync'],

  created() {
    if (typeof this.openerSync != 'undefined') {
      this.openerSync.$on('opened', ({ opened, object, component }) => {
        if (this !== component) {
          this.opened = new Opened()
        }
      })
    }
  },

  computed: {
    hasNext() {
      let index = this.getOpenedIndex()
      let last = this.list.length - 1

      return index !== last
    },

    hasPrev() {
      let index = this.getOpenedIndex()

      return index !== 0
    },
  },

  watch: {
    opened: {
      handler(nval, oval) {
        this.openedProduct = this.items.filter(
          x => this.isElement(this.opened.element, x)
        )[0] || {}

        if (
          this.opened.element != null &&
          typeof this.openerSync != 'undefined'
        ) {
          this.openerSync.$emit('opened', {
            opened: this.opened,
            object: this.openedProduct,
            component: this
          })
        }
      },
      deep: true
    },

    filter: {
      handler(nval, oval) {
        if (this.filter.element) {
          this.list = this.items.filter(x => x.id == this.filter.element)

          if (this.list.length > 0) {
            this.open(this.list[0].id, 0)
          } else {
            this.close()
          }
        } else if (this.filter.group) {
          this.list = this.items.filter(x => x.group == this.filter.group)

          if (this.list.length > 0) {
            this.open(this.list[0].id, 0)
          } else {
            this.close()
          }
        } else {
          this.list = this.items
          this.close()
        }
      },
      deep: true
    },

    openedProduct(nval) {
      if(!this.navigational) return
      if (!(nval && nval.id)) return

      let url = this.openedProduct.alphabet_url

      history.pushState(null, null, url)
    }
  },

  methods: {
    isElement(a, b) {
      return a == b || a == b.id
    },

    getOpenedIndex() {
      return this.list.findIndex(x => x.id == this.openedProduct.id)
    },

    close(toList=false) {
      this.opened = new Opened()

      if (toList && this.navigational) {
        history.pushState(null, null, this.listUrl)
      }
    },

    next() {
      let index = this.getOpenedIndex()
      let last = this.list.length - 1

      index = index == last ? 0 : index + 1

      this.open(this.list[index].id, index)
    },

    prev() {
      let index = this.getOpenedIndex()
      let last = this.list.length - 1

      index = index == 0 ? last : index -1

      this.open(this.list[index].id, index)
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/shared/components/alphabet/alphabet-list.js